import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons';

export interface ISupplierChipsSelectorProps {
  supplier: {id: number | string; name: string};
  expanded: boolean;
  selectedCount: number;
  selectedSet?: Set<number>;
  products: Array<{id: number | string; name: string}>;
  isSaving: boolean;
  onToggle: (supplierId: number) => void;
  onSelect: (supplierId: number, supplierProductId: number) => void;
  onDeselect: (supplierId: number, supplierProductId: number) => void;
  isQueuedForDelete: (supplierId: number, supplierProductId: number) => boolean;
}

export const SupplierChipsSelector: React.FC<ISupplierChipsSelectorProps> = ({
  supplier,
  expanded,
  selectedCount,
  selectedSet,
  products,
  isSaving,
  onToggle,
  onSelect,
  onDeselect,
  isQueuedForDelete,
}) => {
  const supplierId = Number(supplier.id);

  return (
    <article
      className={`primary-suppliers-step__card${
        expanded ? ' is-expanded' : ''
      }`}
    >
      <button
        type="button"
        className="primary-suppliers-step__card-toggle"
        onClick={() => onToggle(supplierId)}
        aria-expanded={expanded}
      >
        <div>
          <h4>{supplier.name}</h4>
          <p>
            {selectedCount > 0
              ? `${selectedCount} ${
                  selectedCount === 1 ? 'product' : 'products'
                } selected`
              : 'No products selected yet'}
          </p>
        </div>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`primary-suppliers-step__chevron${
            expanded ? ' is-expanded' : ''
          }`}
        />
      </button>

      {expanded ? (
        <div className="primary-suppliers-step__card-body">
          <p className="primary-suppliers-step__instruction">
            Tick the products you usually purchase from this supplier.
          </p>
          <div
            className="primary-suppliers-step__chips"
            role="group"
            aria-label={`Products for ${supplier.name}`}
          >
            {products.map((product) => {
              const productId = Number(product.id);
              const isSelected = Boolean(selectedSet?.has(productId));
              const queuedForDelete = isQueuedForDelete(supplierId, productId);

              return (
                <button
                  key={`${supplier.id}-${product.id}`}
                  type="button"
                  className={`primary-suppliers-step__chip${
                    isSelected ? ' is-selected' : ''
                  }${queuedForDelete ? ' is-queued' : ''}`}
                  onClick={() => {
                    if (isSelected) {
                      onDeselect(supplierId, productId);
                      return;
                    }
                    onSelect(supplierId, productId);
                  }}
                  disabled={isSaving}
                  aria-pressed={isSelected}
                >
                  <span className="primary-suppliers-step__chip-label">
                    {product.name}
                  </span>
                  {queuedForDelete ? (
                    <span className="primary-suppliers-step__chip-meta">
                      Queued remove
                    </span>
                  ) : null}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </article>
  );
};
